import { useEffect, useRef, useState } from 'react';

import isFunction from 'utils/function.ts';

import { PlayerProps, StatisticsUpdateEvent } from 'components/Player/types.ts';

export const initialStatisticsState: StatisticsUpdateEvent = {
    url: undefined,
    availableBitrates: undefined,
    streamBitrate: undefined,
    selectedBitrate: undefined,
    downloadBitrate: undefined,
    downloadBitrateAverage: undefined,
    bufferedDuration: undefined,
    totalVideoFrames: undefined,
    droppedVideoFrames: undefined,
    bytesDownloaded: undefined,
};

function useStatisticsUpdateInterval(
    playing: boolean,
    onStatisticsUpdate?: PlayerProps['onStatisticsUpdate'],
    statisticsUpdateInterval: number = 10000,
) {
    const interval = useRef<NodeJS.Timeout | null>(null);
    const downloadBitrateAverageAttempts = useRef(0);

    const [statistics, setStatistics] = useState<StatisticsUpdateEvent>(
        initialStatisticsState,
    );
    const statisticsRef = useRef(statistics);

    useEffect(() => {
        statisticsRef.current = statistics;
    }, [statistics]);

    useEffect(() => {
        if (playing && isFunction(onStatisticsUpdate)) {
            if (interval.current) {
                clearInterval(interval.current);
                interval.current = null;
            }

            interval.current = setInterval(() => {
                onStatisticsUpdate(statisticsRef.current);
            }, statisticsUpdateInterval);
        }

        return () => {
            if (interval.current) {
                clearInterval(interval.current);
                interval.current = null;
            }
        };
    }, [onStatisticsUpdate, playing, statisticsUpdateInterval]);

    return {
        downloadBitrateAverageAttempts,
        setStatistics,
    };
}

export default useStatisticsUpdateInterval;
